import { tokenSchema } from './schema';
import tokens from './tokens.json';

export { ThemeProvider } from '@emotion/react';
export const theme = tokenSchema.parse(tokens);
